import { render, staticRenderFns } from "./passWord.vue?vue&type=template&id=c5fa87d2&scoped=true&"
import script from "./passWord.vue?vue&type=script&lang=js&"
export * from "./passWord.vue?vue&type=script&lang=js&"
import style0 from "./passWord.vue?vue&type=style&index=0&id=c5fa87d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fa87d2",
  null
  
)

export default component.exports